import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BuscaAvancadaService } from '../../services/busca-avancada.service';
import { LoadingComponent } from 'src/app/@theme/components/loading/loading.component';
import { AlertComponent } from 'src/app/@theme/components/alert/alert.component';
import { TypeMenssage } from 'src/app/@theme/model/type-menssage.model';
import { HtmlRenderer, Parser } from 'commonmark'; 

@Component({
    selector: 'app-chat-ai',
    templateUrl: './chat-ai.component.html',
    styleUrls: ['./chat-ai.component.scss'],
    standalone: false
})
export class ChatAiComponent implements OnInit  {

  // @ViewChild('appLoading') public loading: LoadingComponent;
  @ViewChild('alert') public alert: AlertComponent;
  public production: boolean = false;
  public loading: boolean = false;

  public data: any;
  public curDate=new Date();
  public text: string = "";

  constructor(
    private buscaAvancadaService:BuscaAvancadaService
  ) {
    this.production = environment.production;
    this.clear();
  }
  ngOnInit(): void {
  }

  clear() : void {
    this.data = {
      NewQuestion: '',
      Messages: []
    };
  }

  submit(): void {   

    this.data.NewQuestion =this.text; 
    this.loading = true;
    this.buscaAvancadaService.Question(this.data).subscribe(
      respose => {
        this.loading = false;
        this.data = respose;
        this.text = respose.NewQuestion;
      },
      errors => {
        this.loading = false;
        this.alert.Add("Ocorreu um erro interno!", TypeMenssage.danger);
        console.error(errors)
      }
    );
  }

  convert(text) { 
        
    const reader = new Parser();     
    const writer = new HtmlRenderer();    
    const parsed = reader.parse(text);    
    const html = writer.render(parsed);     
    
    return html;  

  } 
}
